import Vue from 'vue'
import filters from '@/filters/filters'
/*  插件 FILTER 开始 */
// const pluginsFilters = require.context('@/plugins', true, /filter\/index\.js$/)
// pluginsFilters.keys().forEach(key => {
//   const objs = pluginsFilters(key).default
//   Object.keys(objs).forEach(key => {
//     Vue.filter(key, objs[key])
//   })
// })
/*  插件 FILTER 结束 */
// Object.keys(filters).forEach(key => {
//   Vue.filter(key, filters[key])
// })

Object.keys(filters).forEach(key => {
  Vue.filter(key, (value) => {
    return filters[key][value + ''] || filters[key]['default'] || ''
  })
})

export default {}
